import axios, { AxiosInstance } from 'axios';

const configuredBaseUrl = process.env.REACT_APP_API_URL?.trim();
const baseURL = configuredBaseUrl && configuredBaseUrl.length > 0
  ? configuredBaseUrl
  : "https://dev.api.babahanks.com";

if (!configuredBaseUrl) {
  console.warn("REACT_APP_API_URL is not set. Falling back to https://dev.api.babahanks.com");
}

const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;